export default __webpack_public_path__ + "static/media/train.788b9d3c.svg";